import { Button } from "@ecco/ui/button";
import { PopoverTrigger } from "@ecco/ui/popover";
import { useBreakpoint } from "@ecco/ui/use-breakpoint";
import type { FC } from "react";
import { styles } from "./styles";

type MarkerTriggerProps = {
    isOpen: boolean;
    onOpen: () => void;
    onToggle: () => void;
    zIndex: number;
};

export const MarkerTrigger: FC<MarkerTriggerProps> = ({ isOpen, onOpen, onToggle, zIndex }) => {
    const lg = useBreakpoint("lg");

    return (
        <PopoverTrigger>
            <Button
                data-testid="popover-trigger-button"
                className="popover-trigger-button"
                aria-label="Toggle hotspot"
                // set onClick on mobile and onMouseEnter on desktop
                onMouseEnter={lg ? onOpen : undefined}
                onClick={onToggle}
                variant="unstyled"
                sx={{
                    ...styles.marker,
                    border: "1px solid",
                    borderColor: isOpen ? "white" : "rgba(255, 255, 255, 0.3)",
                    zIndex,
                    "::before": {
                        content: '""',
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: isOpen ? ["12px", "17.5px"] : ["24px", "35px"],
                        height: isOpen ? ["12px", "17.5px"] : ["24px", "35px"],
                        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "50%",
                        transition:
                            "width 0.25s ease-in, height 0.25s ease-in, border 0.25s ease-in",
                    },
                    ":hover::before": {
                        width: "17.5px",
                        height: "17.5px",
                    },
                }}
                h="100%"
            />
        </PopoverTrigger>
    );
};
